module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row summary-info"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12"
  }, [_c('span', [_c('small', {
    staticClass: "text-muted text-uppercase"
  }, [_vm._v("Shipping Units")]), _c('br'), _vm._v(_vm._s(_vm.rows.length) + "\n            ")]), _vm._v(" "), _c('span', [_c('small', {
    staticClass: "text-muted text-uppercase"
  }, [_vm._v("Density")]), _c('br'), _vm._v(_vm._s(_vm.densityStr) + "\n            ")]), _vm._v(" "), _c('span', [_c('small', {
    staticClass: "text-muted text-uppercase"
  }, [_vm._v("Class")]), _c('br'), _vm._v(_vm._s(_vm.densityClass) + "\n            ")]), _vm._v(" "), _c('span', [_c('small', {
    staticClass: "text-muted text-uppercase"
  }, [_vm._v("Total Weight")]), _c('br'), _vm._v(_vm._s(_vm.totalWeight + ' lbs (' + _vm.totalWeightKgs + ' kgs)') + "\n            ")])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.flattenRows), function(row, shipIndex) {
    return [_c('tr', {
      key: 'shipunit_' + shipIndex
    }, [_c('td', {
      staticClass: "form-group",
      style: ({
        position: 'relative'
      })
    }, [_c('span', [_vm._v(_vm._s(row.description))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "max-width": "80px"
      }
    }, [_c('span', {
      class: {
        shiphide: false
      }
    }, [_vm._v(_vm._s(row.quantity))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "max-width": "80px"
      }
    }, [_c('span', [_vm._v(_vm._s(row.hazardous))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "max-width": "80px"
      }
    }, [_c('span', [_vm._v(_vm._s(row.shippingUnits.join(', ')))])])])]
  })], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Shipping Summary")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Hazardous")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipping Unit(s)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c3fc47f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShippingSummary.vue
// module id = 674
// module chunks = 0